import { createDomainApi } from '@skylabs-digital/react-proto-kit';
import { channelConfigInputSchema, channelConfigSchema } from '../schemas/channelConfig.schema';

export type { ChannelConfig, ChannelConfigInput } from '../schemas/channelConfig.schema';

export const appChannelConfigApi = createDomainApi(
  'channel-config',
  channelConfigSchema,
  channelConfigInputSchema,
);

export const tenantChannelConfigApi = createDomainApi(
  'channel-config/tenants/:tenantId',
  channelConfigSchema,
  channelConfigInputSchema,
);
